import { PipeTransform, Pipe } from '@angular/core';
import { UserHelper } from '@helpers/user.helper';

@Pipe({ name: 'walletControl' })
export class WalletControl implements PipeTransform {
  constructor(public _UserHelper: UserHelper) {}

  transform(value: any, select: 'BranchType' | 'IsVerification'): any {
    if (this._UserHelper.walletList && this._UserHelper.walletList.length > 0) {
      if (select === 'BranchType') {
        return this._UserHelper.walletList.filter(i => i.BranchType === value).length > 0;
      } else if (select === 'IsVerification') {
        return this._UserHelper.walletList.filter(i => i.IsVerification === value).length > 0;
      }
    }
  }
}
